import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './styles';
import { Utility } from 'icons/Utility';
import { TSizeType } from 'interfaces';

type TUtilityBadgeProps = {
  size: TSizeType;
};

export const UtilityBadge: FC<TUtilityBadgeProps> = ({ size = 'medium' }) => {
  const { t } = useTranslation();

  return (
    <Styled.UtilityBadgeWrapper $size={size}>
      <Utility size={20} />
      {size !== 'small' && t('nft.utility')}
    </Styled.UtilityBadgeWrapper>
  );
};
